// Trims app name to remove admin name and "Client" from the end of the name
// Example: "Wildlink Shopping Portal Client" -> "Shopping Portal"
export const trimAppName = (appName: string, adminName: string): string => {
  let trimmedName = appName;
  if (adminName && appName.includes(adminName)) {
    trimmedName = appName.replace(adminName, '').trim();
  }

  const words = trimmedName.split(' ');
  if (words.length > 1) {
    if (words[words.length - 1] === 'Client') {
      trimmedName = words.slice(0, -1).join(' ');
    }
  }
  return trimmedName;
};
